import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button } from '@surfline/quiver-react';

import en from '../../../international/translations/en';
import {
  getSubscriptionPrice,
  parseBillingDate,
  getRenewalPrice
} from '../../../utils/getPlanSubHeadingUtils';
import config from '../../../config';
import { AvailablePlans } from 'components';

export default class PremiumSubscriptions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      validTrial: false,
    };
  }

  componentDidMount() {
    this.validateTrialDate(this.props.sub.periodStart);
  }

  getSubHeading = (subscription, availablePlans, periodEnd, brand) => {
    if (subscription.type === 'apple') return en.subscription.subheading_apple;
    if (subscription.type === 'google') return en.subscription.subheading_google;
    if (subscription.type === 'vip') return en.subscription.subheading_vip[brand];
    if (subscription.expiring) return en.subscription.expiring_message(parseBillingDate(periodEnd), brand);

    // check vaildTrial state
    const subHeading = (subscription.onTrial && this.state.validTrial) ?
      en.subscription.subheading_trial :
      en.subscription.subheading;
    return subHeading(
      this.props.getBillingInterval(subscription),
      parseBillingDate(periodEnd),
      getRenewalPrice(subscription),
      brand
    );
  }

  calculateCurrentPlanAnnualAmount = (subscription) => {
    const amount = getSubscriptionPrice(subscription);
    const interval = this.props.getBillingInterval(subscription);
    let annualAmount;

    if (interval === en.subscription.plans.daily) {
      annualAmount = amount * 365;
    } else if (interval === en.subscription.plans.monthly) {
      annualAmount = amount * 12;
    } else {
      annualAmount = amount;
    }
    return annualAmount;
  }

  validateTrialDate = (startDate) => {
    const today = new Date();
    const diff = Math.floor((Date.parse(today) - Date.parse(startDate)) / 86400000);

    if (diff <= 16) {
      this.setState({
        ...this.state,
        validTrial: true
      });
    }
  }

  generateCancelHref = (sub, brand) => {
    const brandCancelMap = {
      sl: 'surfline.com/cancel/',
      bw: 'buoyweather.com/cancel/',
      fs: 'fishtrack.com/cancel/'
    };
    let cancelHref;
    if (sub.type === 'stripe') {
      cancelHref = `${config.accountLinkProtocol}${brandCancelMap[brand]}${sub.subscriptionId}`;
    } else if (sub.type === 'google') {
      cancelHref = 'https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en';
    } else {
      cancelHref = 'https://support.apple.com/en-us/HT202039';
    }
    return cancelHref;
  };

  handleRenewSubscription = (sub) => {
    const { renewSubscription } = this.props;
    const { stripePlanId } = sub;
    const subsInfo = { plan: stripePlanId };
    renewSubscription(subsInfo);
    window.analytics.track(
      'Clicked Renew Subscription',
      {
        location: 'account-subscription',
        plan: stripePlanId
      }
    );
  }


  /** If the user is on an annual plan, only return their current plan for that brand to prevent them from downgrading to monthly */
  filterCurrentPlan = (sub, brandPlans) => brandPlans.filter(plan => (sub.stripePlanId.match(/annual/g) ? plan.id === sub.stripePlanId : plan.id));

  renderCancelButton = (brandNameMap) => {
    const { sub, brand } = this.props;
    const isExpiring = sub && sub.expiring;
    const hasFailedPayments = sub && sub.failedPaymentAttempts > 0;
    const isVip = sub.type === 'vip';
    if ((!isExpiring || hasFailedPayments) && !isVip) {
      return (
        <div className="subscription__cancel">
          <a onClick={this.analyticsCancelClicked} href={this.generateCancelHref(sub, brand)}>
            {en.subscription.cancel(sub.type, brandNameMap[brand])}
          </a>
        </div>
      );
    }
  }

  render() {
    const {
      updating,
      error,
      sub,
      periodEnd,
      brandPlans,
      brand,
      changePlan
    } = this.props;
    const brandNameMap = {
      sl: 'Surfline',
      bw: 'Buoyweather',
      fs: 'FishTrack'
    };

    return (
      <div className={`subscription__card__${brand}`}>
        <div className="subscription__subheading">
          { this.getSubHeading(sub, brandPlans, periodEnd, brandNameMap[brand])}
        </div>
        {error && <div className="subscription_error__alert">{error.message}</div>}
        {sub.type === 'stripe' && (
          !sub.expiring ?
            <AvailablePlans
              subscription={sub}
              currentPlanAnnualAmount={this.calculateCurrentPlanAnnualAmount(sub)}
              plans={this.filterCurrentPlan(sub, brandPlans)}
              isChanging={updating}
              onSelectHandler={changePlan}
            /> :
            <div className="stayPremium__btn">
              <Button onClick={() => { this.handleRenewSubscription(sub); }} loading={updating}>STAY PREMIUM</Button>
            </div>
        )}
        {this.renderCancelButton(brandNameMap)}
      </div>
    );
  }
}

PremiumSubscriptions.propTypes = {
  subscriptions: PropTypes.object,
  updating: PropTypes.bool,
  sub: PropTypes.object,
  periodEnd: PropTypes.string,
  brandPlans: PropTypes.array,
  brand: PropTypes.string,
  companyMap: PropTypes.array,
  changePlan: PropTypes.func,
  getBillingInterval: PropTypes.func,
  error: PropTypes.object
};
